const SubscriptionId = {
  LevelOne: "1",
  LevelTwo: "2",
  Flex: "flex",
  Startup: "startup",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
type SubscriptionId = (typeof SubscriptionId)[keyof typeof SubscriptionId];

export default SubscriptionId;
